import * as React from 'react';
import * as PropTypes from 'prop-types';

import Logger from '@medflex/utils/Logger';

class ErrorBoundaryEmpty extends React.Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    children: PropTypes.node,
    error: PropTypes.shape({}),
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    this.setState({ hasError: true });
    Logger.error(error);
  }

  render() {
    const { hasError } = this.state;
    const { children, error } = this.props;

    if (!hasError && !error) return children;

    return null;
  }
}

export default ErrorBoundaryEmpty;
